module.exports = __webpack_public_path__ + "static/media/YM16_3.20a5a564.jpg";